import InlineTable from '../primitives/InlineTable';
import { buildBreadcrumb } from '../lib/breadcrumbFormat';
import {
    buildColumns,
    buildRows,
    parentName,
    pinnedTitleParts,
    excludedTerms,
} from '../lib/tableHelpers';
import type { TableModel, VisualProps, VisualWidget } from '../types';

const NAME_KEY = 'category_name';
const TYPE_LABEL = 'Related categories';

function buildRelatedCategoriesTableModel({
    input,
    output,
    title: customTitle,
}: VisualProps): TableModel {
    const affinity = input?.affinity_group;
    const firstAffinity = affinity?.[0];
    const noun =
        Array.isArray(affinity) && affinity.length > 0
            ? affinity.join(' & ')
            : 'related categories';
    const columns = buildColumns(input?.order_by);
    return {
        breadcrumb: buildBreadcrumb(output, TYPE_LABEL),
        title: {
            custom: customTitle || undefined,
            parent: parentName(output),
            noun,
            ...pinnedTitleParts(output, NAME_KEY),
            ...excludedTerms(input, output),
            lifeCycle: input?.life_cycle,
        },
        link: output?.result?.dashboard_url,
        nameColumnHeader: firstAffinity || 'Category',
        columns,
        rows: buildRows(output, columns, NAME_KEY),
    };
}

const RelatedCategoriesInlineTable = ({
    Frame,
    dense,
    onExcludeRow,
    ...props
}: VisualProps) => (
    <InlineTable
        {...buildRelatedCategoriesTableModel(props)}
        Frame={Frame}
        dense={dense}
        onExcludeRow={onExcludeRow}
    />
);

const widget: VisualWidget = {
    match: (input) => input?.entity_relationship === 'related_categories',
    Component: RelatedCategoriesInlineTable,
};

export default widget;
